import { render, staticRenderFns } from "./AddMiniProjects.vue?vue&type=template&id=19e292d2&scoped=true"
import script from "./AddMiniProjects.vue?vue&type=script&lang=js"
export * from "./AddMiniProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e292d2",
  null
  
)

export default component.exports